import { useEffect, useRef, useState, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
// store
// store
import { clearFilter, setLoading } from "../../configureStore";
// helpers
import emptyFilters from "../../helper/emptyFilters";
import debounce from "../../helper/debounce";
// components
import PillsList from "./pillsList";
import PillsModal from "./pillsModal";
import PillsCounterBtn from "./pillsCounterBtn";
import ClearPillsButton from "./clearPillsButton";

const Pills = () => {
	const ulRef = useRef();
	const dispatch = useDispatch();
	const [hiddenCount, setHiddenCount] = useState(null);
	const [pillsFilters, setPillsFilters] = useState(null);
	const [modalState, setModalState] = useState(false);
	const [counterVisible, setcounterVisible] = useState(true);
	const searchData = useSelector((state) => state.searchData);
	const global = useSelector((state) => state.global);
	const listRef = useCallback((node) => {
		// if counter is clicked prevent width check
		if (!ulRef.current) {
			ulRef.current = node;
		}
		if (!counterVisible || !pillsFilters) {
			return;
		}
		if (node !== null) {
			widthCheck();
		}
	});

	useEffect(() => {
		if (emptyFilters(searchData.filters)) {
			setPillsFilters(null);
			setHiddenCount(null);
			setcounterVisible(true);
		} else {
			setPillsFilters(true);
		}
	}, [searchData]);

	useEffect(() => {
		if (document.querySelector(".layout-full")) {
			document.documentElement.style.setProperty(
				"--offset-top",
				document.querySelector(".layout-full").offsetTop + "px",
			);
		}
	}, [pillsFilters]);
	useEffect(() => {
		const debouncedHandleResize = debounce(function handleResize() {
			if (emptyFilters(searchData.filters)) return;
			if (window.innerWidth > 768) {
				setcounterVisible(true);
				document.body.classList.remove("wrapped");
			}
			widthCheck();
		}, 1000);

		window.addEventListener("resize", debouncedHandleResize);
		return (_) => {
			window.removeEventListener("resize", debouncedHandleResize);
		};
	});
	// check items rendered width and hide the ones which are overflowing
	const widthCheck = () => {
		const parent = document.querySelector(".pills__list");
		const container = parent.closest(".pills__block");
		const wrapperWidth =
			container.querySelector(".pills__controls").clientWidth;
		const parentWidth = container.clientWidth;
		const parentGap = Number(
			getComputedStyle(parent.closest(".pills__block")).gap.split("px")[0],
		);
		const contWidth = parentWidth - wrapperWidth - parentGap;
		const pillsChildren = [...parent.children];
		const childrenGapCount = Number(
			getComputedStyle(parent).gap.split("px")[0],
		);
		let pillsChildrenWidth = 0;
		pillsChildren.forEach((pill) => {
			pill.classList.remove("hidden");
			pillsChildrenWidth += Math.ceil(pill.clientWidth) + childrenGapCount;
			if (pillsChildrenWidth + childrenGapCount > contWidth) {
				pill.classList.add("hidden");
			}
		});
		if (parent.querySelectorAll(".hidden").length) {
			setHiddenCount(parent.querySelectorAll(".hidden").length);
		} else {
			setHiddenCount(null);
		}
	};

	const modalPillsState = () => {
		setModalState(false);
	};
	const clearFlters = async () => {
		await dispatch(clearFilter());
		setcounterVisible(true);
		document.body.classList.remove("wrapped");
		dispatch(setLoading(true));
	};
	const toggleHidden = () => {
		const pillsChildren = document.querySelectorAll(".pills__list .hidden");
		pillsChildren.forEach((pill) => {
			pill.classList.remove("hidden");
		});
		setcounterVisible(false);
		setHiddenCount(null);
		document.body.classList.add("wrapped");
	};

	return (
		<div className="pills">
			<div className="wrapper">
				<div className="pills__block">
					<div className="pills__container">
						{!emptyFilters(searchData.filters) ? (
							<PillsList ref={listRef} />
						) : null}
					</div>
					<div className="pills__controls">
						{pillsFilters && hiddenCount ? (
							<PillsCounterBtn
								className={"pills__counter--mobile"}
								visible={counterVisible}
								callback={setModalState}
								text={hiddenCount}
							/>
						) : null}
						{pillsFilters && hiddenCount ? (
							<PillsCounterBtn
								className={"pills__counter--desktop"}
								visible={counterVisible}
								callback={toggleHidden}
								text={hiddenCount}
							/>
						) : null}
						{pillsFilters ? (
							<ClearPillsButton
								text={global.localization.clearFilters}
								callback={clearFlters}
							/>
						) : null}
					</div>
				</div>
			</div>
			<PillsModal
				toggleModal={modalState}
				callback={modalPillsState}
			/>
		</div>
	);
};

export default Pills;
